import React from "react";
import { Button, Input, Label, Row, Col, FormGroup } from "reactstrap";
import Contact from "components/Contact";
import api from "../../api";
import _ from "lodash";
import "./index.css";
import ErrorService from "services/ErrorService";
import t from "utils/Lang";

export default class SiteContactView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locationContact: {},
      locationContacts: [],
      contact: {},
      contactSearchResults: [],
      currentUser: null,
    };
    this.search = _.debounce(this.search, 300);
    this.getLocationContact = this.getLocationContact.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
  }
  componentDidMount() {
    this.getCurrentUser();
    this.getLocationContact();
  }
  onModalClose() {
    this.setState({
      isCreateNewContact: false,
    });
  }
  getCurrentUser() {
    api.fetchAPI({
      method: "get",
      uri: `userme/me`,
      success: (response) => {
        if (response.result) {
          const currentUser = response.result;
          this.setState({
            currentUser,
          });
        } else {
          alert("Failed to get user: " + response.msg);
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  getLocationContact() {
    const { locationId } = this.props;
    if (!locationId) return;
    api.fetchAPI({
      method: "get",
      uri: `site_contact/?q=(filters:!((col:site,opr:rel_o_m,value:${locationId}),(col:is_active,opr:eq,value:1)))`,
      success: (response) => {
        if (response.result) {
          this.setState({
            locationContacts: response.result,
            isCreateNewContact: false,
          });
        } else {
          ErrorService.showError(response.msg || response.message);
        }
      },
    });
  }
  addContactToLocation(contactToAdd) {
    const { locationId } = this.props;
    const { currentUser } = this.state;

    const locationContactToUpload = {
      site: {
        id: locationId,
      },
      contact: {
        id: contactToAdd.id,
      },
      created_by: {
        id: currentUser.id,
      },
      changed_by: {
        id: currentUser.id,
      },
    };

    api.fetchAPI({
      method: "post",
      body: locationContactToUpload,
      uri: "site_contact/",
      success: (response) => {
        if (response.result) {
          locationContactToUpload.id = response.id;
          this.setState(
            {
              isSearchForExistingContact: false,
            },
            this.getLocationContact
          );
        } else {
          alert(response.msg);
        }
      },
    });
  }
  searchForContact(keywords) {
    this.setState(
      {
        keywords,
      },
      this.search
    );
  }
  search() {
    const { keywords } = this.state;
    if (!keywords) return;
    api.fetchAPI({
      method: "get",
      uri: `contact/search?q=${keywords}`,
      success: (response) => {
        if (response.result) {
          this.setState({
            contactSearchResults: response.result.result,
          });
        }
      },
    });
  }
  render() {
    const { locationId } = this.props;
    const {
      locationContacts,
      isCreateNewContact,
      isSearchForExistingContact,
      contactSearchResults,
    } = this.state;
    return (
      <div>
        <Row>
          <Col xs={12}>
            <div className="site-contact__row" style={{ marginBottom: 15 }}>
              <Button
                color="primary"
                onClick={() => this.setState({ isCreateNewContact: true })}
              >
                {t().action__create_new}
              </Button>
              <Button
                style={{ marginLeft: 15 }}
                color="primary"
                onClick={() =>
                  this.setState({ isSearchForExistingContact: true })
                }
              >
                {t().action__add_owner}
              </Button>
            </div>
          </Col>
        </Row>
        {isSearchForExistingContact && (
          <Row>
            <Col xs={12}>
              <FormGroup>
                <Input
                  type="text"
                  placeholder={t().site_rental_information__contact_placeholder}
                  onChange={(e) => this.searchForContact(e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
        )}
        {isSearchForExistingContact && contactSearchResults && (
          <Row>
            {contactSearchResults.map((contactSearchResult, index) => (
              <Col xs={12} key={index}>
                <div>
                  <h4>
                    {contactSearchResult.last_name}{" "}
                    {contactSearchResult.middle_name}{" "}
                    {contactSearchResult.first_name}
                  </h4>
                  <p>
                    {t().site_rental_information__phone_number}:{" "}
                    {contactSearchResult.primary_phone}
                  </p>
                  <FormGroup>
                    <Button
                      size="sm"
                      color="primary"
                      onClick={() =>
                        this.addContactToLocation(contactSearchResult)
                      }
                    >
                      {t().action__add}
                    </Button>
                  </FormGroup>
                </div>
              </Col>
            ))}
          </Row>
        )}
        {isCreateNewContact && (
          <Contact
            isSite
            locationId={locationId}
            isCreateNewContact={isCreateNewContact}
            onContactCreated={this.getLocationContact}
            onModalClose={this.onModalClose}
            isModalOpen
          />
        )}
        {locationContacts.map((locationContact) => (
          <div key={locationContact.id}>
            <Contact
              isSite
              locationId={locationId}
              locationContact={locationContact}
            />
          </div>
        ))}
      </div>
    );
  }
}
